import actionTypes from '../actionTypes';

const initialState = {
  activeStickerId: null,
  canDragSticker: true,
  stickerIdList: [],
  stickerPreviewList: [],
  stickerCounter: 0,
  visualizeStickerCounter: 0,
  refreshStickerPreview: false
};

export default function stickerReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_STICKER_ID:
      return {
        ...state,
        activeStickerId: action.payload.id
      };
    case actionTypes.SET_STICKER_ID_LIST:
      return {
        ...state,
        stickerIdList: action.payload.list
      };
    case actionTypes.SET_STICKER_PREVIEW_LIST:
      return {
        ...state,
        stickerPreviewList: action.payload.list
      };
    case actionTypes.SET_ENABLE_OR_DIABLE_STICKER_DRAG:
      return {
        ...state,
        canDragSticker: action.payload.canDrag
      };
    case actionTypes.SET_STICKER_COUNTER:
      return {
        ...state,
        stickerCounter: action.payload.counter
      };
    case actionTypes.SET_VISUALIZE_STICKER_COUNTER:
      return {
        ...state,
        visualizeStickerCounter: action.payload.counter
      };
    case actionTypes.SET_REFRESH_STICKER_PREVIEW:
      return {
        ...state,
        refreshStickerPreview: !state.refreshStickerPreview
      };

    default:
      return state;
  }
}
